module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/_main-visual-text-7e1049887ce6ae81163a7217d54b8189.svg";